import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Thumbtack = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="thumbtack icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M4 1.5C4 0.671573 4.67157 0 5.5 0H18.5C19.3284 0 20 0.671573 20 1.5C20 2.32843 19.3284 3 18.5 3H15.937C15.9781 3.15981 16 3.32735 16 3.5V8.13354C16 8.68635 16.2288 9.21452 16.6321 9.59261L20.3103 13.0409C21.633 14.281 20.7555 16.5 18.9424 16.5H14V22L12 24L10 22V16.5H5.05755C3.24448 16.5 2.36697 14.281 3.68967 13.0409L7.36787 9.59261C7.77118 9.21452 7.99999 8.68635 7.99999 8.13354V3.5C7.99999 3.32735 8.02187 3.15981 8.063 3H5.5C4.67157 3 4 2.32843 4 1.5Z"
    />
  </svg>
)
